import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  analyticsConfigured, getConsent, setConsent, loadAnalytics, installClickTracking, trackPage,
} from "../lib/analytics";

// Only appears once analytics is configured, and only until the visitor chooses.
const ConsentBanner = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const es = pathname.startsWith("/espanol");

  useEffect(() => {
    if (!analyticsConfigured()) return;
    installClickTracking();
    const c = getConsent();
    if (c === "granted") loadAnalytics();
    else if (!c) setOpen(true);
  }, []);

  useEffect(() => { trackPage(pathname); }, [pathname]);

  if (!open) return null;

  const choose = (v) => { setConsent(v); setOpen(false); };

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label={es ? "Preferencias de cookies" : "Cookie preferences"}
      className="fixed z-[60] inset-x-3 bottom-20 md:bottom-4 md:left-4 md:right-auto md:max-w-md bg-ink text-white border border-white/15 rounded-xl shadow-2xl p-5"
    >
      <p className="text-sm text-white/80 leading-relaxed">
        {es
          ? "Usamos Google Analytics para saber qué páginas ayudan a los clientes. Solo se activa si usted lo acepta."
          : "We use Google Analytics to see which pages help homeowners. It only turns on if you allow it."}{" "}
        <Link to="/privacy-policy" className="underline hover:text-brand">
          {es ? "Política de Privacidad" : "Privacy Policy"}
        </Link>
      </p>
      <div className="flex gap-3 mt-4">
        <button type="button" onClick={() => choose("granted")}
          className="flex-1 bg-brand hover:bg-brand-light text-ink font-semibold text-sm px-4 py-2.5 rounded-md transition-colors">
          {es ? "Aceptar" : "Allow"}
        </button>
        <button type="button" onClick={() => choose("denied")}
          className="flex-1 border border-white/25 hover:border-brand text-sm px-4 py-2.5 rounded-md transition-colors">
          {es ? "No, gracias" : "No thanks"}
        </button>
      </div>
    </div>
  );
};

export default ConsentBanner;
